import { render } from "./TicketsModal.vue?vue&type=template&id=8b4582f6"
import script from "./TicketsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./TicketsModal.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/modals/TicketsModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8b4582f6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8b4582f6', __exports__)) {
    api.reload('8b4582f6', __exports__)
  }
  
  module.hot.accept("./TicketsModal.vue?vue&type=template&id=8b4582f6", () => {
    api.rerender('8b4582f6', render)
  })

}


export default __exports__